// このファイルは apps/web/scripts/fetch_he_fonts.mjs が作ります。手で直さないこと。
/** クイズの1組。a か b のどちらが出ているかを当ててもらう。 */
export interface QuizPair {
  id: string;
  title: string;
  note: string;
  a: { ch: string; label: string; code: string };
  b: { ch: string; label: string; code: string };
  /** 2つの形が違う書体。これだけ出題に使う */
  fonts: readonly string[];
  /** まったく同じ形だった書体。出題には使わないが、話のネタになる */
  same: readonly string[];
}

export const QUIZ_PAIRS: readonly QuizPair[] = [
  {
    id: 'he',
    title: 'へ',
    a: {
      ch: 'へ',
      label: 'ひらがな',
      code: 'U+3078',
    },
    b: {
      ch: 'ヘ',
      label: 'カタカナ',
      code: 'U+30D8',
    },
    note: 'ひらがなの「へ」と、カタカナの「ヘ」',
    fonts: [
      'Hina Mincho',
      'Yuji Boku',
      'Kaisei Decol',
      'Hachi Maru Pop',
      'DotGothic16',
      'Yomogi',
      'BIZ UDPMincho',
      'Kaisei HarunoUmi',
      'Kaisei Opti',
      'Zen Kurenaido',
      'New Tegomin',
      'Shippori Mincho',
      'Zen Old Mincho',
      'Rampart One',
      'Zen Kaku Gothic New',
      'Train One',
      'Yusei Magic',
      'M PLUS 1p',
      'M PLUS Rounded 1c',
      'Kiwi Maru',
      'Zen Maru Gothic',
      'Kosugi Maru',
      'Yuji Syuku',
      'Kosugi',
      'Kaisei Tokumin',
      'Zen Antique',
      'Mochiy Pop One',
      'Noto Serif JP',
      'Noto Sans JP',
      'Potta One',
      'BIZ UDPGothic',
      'Klee One',
      'Dela Gothic One',
    ],
    same: ['Reggae One', 'RocknRoll One', 'Stick'],
  },
  {
    id: 'ro',
    title: 'ロ',
    a: {
      ch: 'ロ',
      label: 'カタカナ',
      code: 'U+30ED',
    },
    b: {
      ch: '口',
      label: '漢字',
      code: 'U+53E3',
    },
    note: 'カタカナの「ロ」と、漢字の「口（くち）」',
    fonts: [
      'Zen Kaku Gothic New',
      'Kaisei HarunoUmi',
      'Shippori Mincho',
      'Hina Mincho',
      'Zen Old Mincho',
      'New Tegomin',
      'Noto Serif JP',
      'Kaisei Tokumin',
      'Kiwi Maru',
      'Train One',
      'Zen Maru Gothic',
      'BIZ UDPMincho',
      'Kaisei Decol',
      'Kaisei Opti',
      'Hachi Maru Pop',
      'Zen Antique',
      'Potta One',
      'Yuji Syuku',
      'Klee One',
      'Zen Kurenaido',
      'Rampart One',
      'Yomogi',
      'DotGothic16',
      'BIZ UDPGothic',
      'Yuji Boku',
      'Noto Sans JP',
      'M PLUS Rounded 1c',
      'M PLUS 1p',
      'Stick',
      'RocknRoll One',
      'Mochiy Pop One',
      'Reggae One',
      'Yusei Magic',
      'Dela Gothic One',
      'Kosugi',
      'Kosugi Maru',
    ],
    same: [],
  },
  {
    id: 'e',
    title: 'エ',
    a: {
      ch: 'エ',
      label: 'カタカナ',
      code: 'U+30A8',
    },
    b: {
      ch: '工',
      label: '漢字',
      code: 'U+5DE5',
    },
    note: 'カタカナの「エ」と、漢字の「工（こう）」',
    fonts: [
      'Zen Kurenaido',
      'Hina Mincho',
      'Zen Maru Gothic',
      'Shippori Mincho',
      'Zen Kaku Gothic New',
      'Zen Old Mincho',
      'New Tegomin',
      'Klee One',
      'Kaisei HarunoUmi',
      'Noto Serif JP',
      'Train One',
      'Kaisei Tokumin',
      'BIZ UDPMincho',
      'Zen Antique',
      'Kiwi Maru',
      'Kaisei Decol',
      'Rampart One',
      'Kaisei Opti',
      'Noto Sans JP',
      'Yusei Magic',
      'Yuji Syuku',
      'Kosugi',
      'Yuji Boku',
      'Reggae One',
      'Kosugi Maru',
      'M PLUS 1p',
      'M PLUS Rounded 1c',
      'RocknRoll One',
      'Potta One',
      'Yomogi',
      'Hachi Maru Pop',
      'BIZ UDPGothic',
      'Mochiy Pop One',
      'Stick',
      'Dela Gothic One',
      'DotGothic16',
    ],
    same: [],
  },
  {
    id: 'ta',
    title: 'タ',
    a: {
      ch: 'タ',
      label: 'カタカナ',
      code: 'U+30BF',
    },
    b: {
      ch: '夕',
      label: '漢字',
      code: 'U+5915',
    },
    note: 'カタカナの「タ」と、漢字の「夕（ゆう）」',
    fonts: [
      'Noto Serif JP',
      'Shippori Mincho',
      'Zen Old Mincho',
      'Hachi Maru Pop',
      'Kaisei HarunoUmi',
      'Zen Kurenaido',
      'Yuji Boku',
      'DotGothic16',
      'Zen Kaku Gothic New',
      'Klee One',
      'Zen Antique',
      'Hina Mincho',
      'Yomogi',
      'Kaisei Tokumin',
      'New Tegomin',
      'Zen Maru Gothic',
      'Stick',
      'BIZ UDPMincho',
      'Train One',
      'Kosugi',
      'Kiwi Maru',
      'Mochiy Pop One',
      'M PLUS 1p',
      'Yuji Syuku',
      'M PLUS Rounded 1c',
      'Kosugi Maru',
      'Kaisei Opti',
      'Yusei Magic',
      'Reggae One',
      'Kaisei Decol',
      'Rampart One',
      'Potta One',
      'Noto Sans JP',
      'BIZ UDPGothic',
      'RocknRoll One',
      'Dela Gothic One',
    ],
    same: [],
  },
];
